"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Inner = exports.Outer = void 0;

const react_1 = __importDefault(require("react"));

const styled_components_1 = __importDefault(require("styled-components"));
/**
 * The AspectRatio provides its children with a width and a height based on the
 * ratio prop.
 *
 * @example ```
 *   <AspectRatio aspectRatio={16 / 9}>
 *     ...
 *   </AspectRatio>
 * ```
 *
 * NB: This component uses the good old relative padding trick. This means that
 * the AspectRatio component will only work correctly if the parent has a
 * calculable width.
 * @see https://css-tricks.com/aspect-ratio-boxes/
 *
 * NB: This component is inspired by, but not identical to the Flutter
 * equivalent.
 * @see https://api.flutter.dev/flutter/widgets/AspectRatio-class.html
 */


const AspectRatio = _a => {
  var {
    children
  } = _a,
      props = __rest(_a, ["children"]);

  return react_1.default.createElement(exports.Outer, Object.assign({}, props), react_1.default.createElement(exports.Inner, null, children));
};

exports.default = AspectRatio;
exports.Outer = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-top: ", "%;\n"])), props => 100 / props.aspectRatio);
exports.Inner = styled_components_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));